import React from 'react'
import { type RecurringRepairLicense, type RecurringRepairSubscription } from '../types/recurring-repair.types'
import StandardLicenseBox from '../../order-status/components/StandardLicenseBox';

import LicenseItem from './LicenseItem';

type Props = {
    sub: RecurringRepairSubscription
}

export default function LicenseSummary({sub}: Props) {
    if (!sub){
        return <></>
    }
    const lics = sub.licenses;
    const licBoxes: React.JSX.Element[] = [];

    lics.forEach((l: RecurringRepairLicense) => {
        licBoxes.push((
            <LicenseItem license={l} currencyIso={sub.currencyCode} />
        ))
    })

    return (
        <div>
            <h2>Licenses</h2>
            <div className='order-line-items-container'>
                
                {licBoxes}
            </div>
        </div>
    )
}